import React, { type ReactNode } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import type { Stripe } from '@stripe/stripe-js';

export interface IsolatedStripeElementsProps {
  /** Second (and further) card groups must use their own Elements instance — Stripe allows only one cardNumber per instance. */
  stripe: PromiseLike<Stripe | null> | null;
  children: ReactNode;
}

export function IsolatedStripeElements({
  stripe,
  children,
}: IsolatedStripeElementsProps): React.ReactElement | null {
  if (!stripe) {
    return null;
  }
  return <Elements stripe={stripe}>{children}</Elements>;
}
